import classnames from 'classnames';
import { GROUND_TRIP_STATUSES } from '@lp/features/RoutePlanner/config';
import { GroundTripStatus } from '@/api/apis/drive-service';

const STATUS_CHIP_COLOR_BY_TYPE: Record<GroundTripStatus, string> = {
  [GroundTripStatus.New]: 'bg-[#585E71]',
  [GroundTripStatus.Pending]: 'bg-[#FF8A00]',
  [GroundTripStatus.Planned]: 'bg-[#0F993E]',
  [GroundTripStatus.InProgress]: 'bg-[#0092A6]',
  [GroundTripStatus.Completed]: 'bg-base-5',
  [GroundTripStatus.Cancelled]: 'bg-danger-20',
  [GroundTripStatus.Merged]: 'bg-base-30',
};

type TripStatusChipProps = {
  status: GroundTripStatus;
};

export const TripStatusChip = ({ status }: TripStatusChipProps) => {
  const statusBgClass = STATUS_CHIP_COLOR_BY_TYPE[status];
  const statusTitle = GROUND_TRIP_STATUSES[status];

  return (
    <div className={classnames('flex items-center py-0.5 px-2 rounded-2xl shrink-0', statusBgClass)}>
      <span className="text-s-sb text-base-90">{statusTitle}</span>
    </div>
  );
};
